module.exports = __webpack_public_path__ + "static/img/12.0339949.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/1/eng/12.png
// module id = P/tL
// module chunks = 0